import EntityIcon from './EntityIcon';

export default EntityIcon;
